import React from "react"

interface Props {}

/**
 * Lightweight wrapper used to group adjacent `ContextRoute` siblings under a
 * single React node. Avoids adding extra semantics or styles.
 */
const Bundle: React.FC<Props> = (props) => <div {...props} />

export default Bundle
